import { getTablePresets } from '../services';
export const fetchTablePresets = () => getTablePresets().then(response => formatPresets(response?.data));
const formatPresets = (response) => {
    return {
        all: response?.presets?.all,
        integration: response?.presets?.integration,
    };
};
